// extracted by mini-css-extract-plugin
export var border = "_16-7";
export var brand = "_16-r";
export var button = "_16-j";
export var center = "_16-9";
export var centered = "_16-5";
export var closeButton = "_16-b";
export var disabledWrapper = "_16-k";
export var error = "_16-n";
export var extraLarge = "_16-4";
export var extraSmall = "_16-1";
export var fill = "_16-g";
export var footer = "_16-f";
export var footerAction = "_16-h";
export var footerButtons = "_16-i";
export var header = "_16-6";
export var icon = "_16-m";
export var info = "_16-q";
export var inline = "_16-8";
export var large = "_16-3";
export var main = "_16-c";
export var modal = "_16-0";
export var neutral = "_16-s";
export var noPadding = "_16-e";
export var none = "_16-t";
export var scrollable = "_16-d";
export var small = "_16-2";
export var success = "_16-p";
export var tight = "_16-l";
export var titleIcon = "_16-a";
export var warn = "_16-o";